import React, { Component } from 'react';
import {observer} from 'mobx-react';
//import {toJS} from 'mobx';
import { TextField, Select, MenuItem, InputLabel, FormControl, Divider,
         IconButton, Tooltip, Button, Typography,
         Dialog, DialogTitle, DialogContent, DialogActions,
         CircularProgress } from '@mui/material';
import { CancelOutlined, AddCircleOutline } from '@mui/icons-material';
import { NavLink } from 'react-router-dom';
import styled from 'styled-components';

import { AppStates } from './FlowStore';

const toolTipDelay = 2000;

const CardContainerDiv = styled.div`
  height: 100%;
  width: 100%;
  overflow-y: scroll;
  padding-left: 15px;
  padding-right: 15px;
  padding-bottom: 10px;
`;

const SpinnerContainerDiv = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 100%;
`;

const StyledHeader = styled.h5`
  margin-bottom:10px;
  margin-top:10px;
`;

const StyledInputLabel = styled(InputLabel)`
  background-color: white;
  padding-left: 2;
  padding-right: 2;
`;

const IssueContainerDiv = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 10px;
`;

const InnerRefContainerDiv = styled(IssueContainerDiv)`
  margin-bottom: 0px;
`;

const issueDataFieldName = {
  '101': 'Claims', '102': 'Claims', '103': 'Claims', 'ns_dp': 'Claims',
  '112p1': 'Claims', '112p2': 'Claims', 'allow': 'Claims', 'obj.inf': 'Claims',
  'obj.draw': 'Figures', 'obj.spec': 'Paragraphs', 'missing.fees': 'Amount',
  'missing.dec': 'Inventors', 'restriction.grp': 'Claims',
  'other': 'Notes', 'refs.cited': 'Notes', '': 'Notes',
  
  'tm.disclaimer': 'Wording', 'tm.specimen': 'Notes', 'tm.indefinite': 'Wording',
  'tm.significance': 'Notes', 'tm.multiclass': 'Classes', 'tm.translation':'Notes',
  'tm.description': 'Notes', 'tm.confusion': 'Notes',

  'pct.novelty': 'Claims', 'pct.inventive': 'Claims', 'pct.ia': 'Claims',
  'pct.unity': 'Claims', 'pct.clarity': 'Claims', 
  'pct.other': 'Notes'
}

const documentChains = {
  'PAT.FR': ['a Filing Receipt',
             'a Notice to File Missing Parts or a Notice to File Corrected Application Papers'],
  'PCT.ISR': ['an International Search Report',
              'a Written Opinion of the Search Authority']
}


@observer
class CardContent extends Component {
  constructor(props) {
    super(props);
    this.store = props.store;
    this.state = {
      frWarning:false,
      isOpen:false
    };
    //console.log('constructor!')
    this.handleChange = this.handleChange.bind(this);
  }

  // componentDidUpdate(prevProps) {
  //   let doc = this.props.store
  //   console.log('cdu');
  //   console.log(doc.currentIssue);
  //   console.log(this.state.references);
  //   console.log(this.state.basis);
  //   if (prevProps.doc.matter !== doc.matter) {
  //     this.setState(() => ({ matter: doc.matter }));
  //   }
  //   if (prevProps.doc.currentIssue !== doc.currentIssue &&
  //       doc.currentIssue !== null &&
  //       doc.rejections !== null) {
  //     let rejection = doc.rejections[doc.currentIssue];
  //     this.setState(prevState => (
  //       { basis: rejection.basis, claims: rejection.claims, references: rejection.references }
  //     ));
  //   }
  // }

  handleClose() {
    this.setState(prevState => ({ isOpen: false }));
  }
  handleOpen() {
    this.setState(prevState => ({ isOpen: true }));
  }

  handleChange(e, attr) {
    let val = e.target.value;
    console.log('HandleChange', val);
    this.setState(prevState => (
      {...prevState, matter: { ...prevState.matter, [attr]: val }}
    ));
  }

  chainInfo() {
    if (this.store.docType in documentChains)
      return documentChains[this.store.docType];
    return ['_', '_'];
  }

  metaFields() {
    let myAttributes = this.store.getDocAttributes(this.store.docType);
    //console.log(myAttributes);
    //let theMatter = this.store.matter;
    //console.log('Stored matter', toJS(this.store.matter));
    const metaFields = myAttributes.map((attr, i) => {
      return (
        <TextField
          key={`attr_${i}`}
          style={{width:"100%"}}
          label={this.store.docAttributeNames[attr]}
          //defaultValue={this.store.matter[attr] || ''}
          value={this.store.matter[attr] || ''}
          onChange={e => {
            //console.log('OnChange', e.target.value);
            this.store.matter[attr] = e.target.value;
          }}
          onBlur={e => {
            //console.log('Onblur', e.target.value);
            if (attr === 'app_num' || attr === 'serial_num') {
              console.log('Looking up', e.target.value);
              this.store.lookupMatter(e.target.value);
            }
          }}
        />
      );
    });
    return metaFields;
  }

  renderRejectionInfo() {
    if (!this.store.haveMatterInfo()) {
      return (
        <SpinnerContainerDiv>
          <CircularProgress />
        </SpinnerContainerDiv>
      );
    }
    if (this.store.currentIssue === null) {
      //console.log('Doctype = ' + this.store.docType);
      
      return (
        <div>
          <Dialog
            ref="frDialog"
            icon="flag"
            open={!this.state.frWarning && this.store.docType in documentChains}
          >
            <DialogTitle>
              Hint
            </DialogTitle>
            <Divider />
            <DialogContent>
              It looks like you have loaded {this.chainInfo()[0]}.
              If you also received {this.chainInfo()[1]},
              we suggest returning to the home screen and loading that document instead.
            </DialogContent>
            <DialogActions>
              <NavLink to="/dashboard">
                <Button
                  variant='contained'
                  disableElevation
                  margin='dense'
                  onClick={() => {
                    console.log('Go home');
                    this.setState(prevState => ({frWarning: true}));
                    this.store.appState = AppStates.DASHBOARD;
                    this.store.resetGettingResults();
                    this.store.resetWorkspace('');
                  }}
                >
                  Home
                </Button>
              </NavLink>
              <Button
                color='primary' variant='contained'
                disableElevation
                onClick={() => {
                  console.log('Continue');
                  this.setState(prevState => ({frWarning: true}));
                }}
              >
                Continue
              </Button>
            </DialogActions>
          </Dialog>
          
          <FormControl style={{marginTop:"2em"}} margin='dense' fullWidth variant='outlined'>
            <StyledInputLabel shrink id='doctype-select-label'>
              Select Document Type
            </StyledInputLabel>
            <Select
              labelId='doctype-select-label'
              value={this.store.docType || ''}
              renderValue={value => {
                //console.log('Render', this.store.docTypeLabel(value));
                return this.store.docTypeLabel(value).label;
              }}
              size='small'
              onChange = {e => {
                this.store.setDocType(e.target.value);
              }}
            >
              {this.store.docTypeLabels.map((item, index) => {
                return (
                  <MenuItem key={`doctype_${index}`} value={item.value}>{item.label}</MenuItem>
                );
              })}
            </Select>
          </FormControl>
          <hr/>
          
          {this.metaFields()}
          
          <IssueContainerDiv>
            {this.store.isFreeDemo() ? '' :
             <Button
               variant='contained' color='secondary' disableElevation
               onClick={() => this.handleOpen()}
             > 
               Delete Workspace
             </Button>
            }
            <Dialog
              title="Confirm Deletion"
              icon="warning-sign"
              open={this.state.isOpen}
              onClose={() => this.handleClose()}
              //{...this.state}
            >
              <DialogTitle>Confirm Deletion</DialogTitle>
              <Divider />
              <DialogContent>
                <Typography variant="body1">
                  Deleting the current workspace will delete the current document and related files!  Are you sure?
                </Typography>
              </DialogContent>
              <DialogActions>
                <Button
                  color='secondary' disableElevation
                  variant='contained'
                  onClick={() => this.handleClose()}
                >
                  Cancel
                </Button>
                <Button
                  icon="delete"
                  color='primary' disableElevation
                  variant='contained'
                  onClick={() => {
                    this.handleClose();
                    this.store.deleteWorkspace();
                    this.store.appState = AppStates.DASHBOARD;
                  }}
                >
                  Yes, Delete
                </Button>
              </DialogActions>
            </Dialog>
          </IssueContainerDiv>
        </div>
      );
    }

    //console.log('Rendering issue card');
    //console.log(toJS(this.store.rejections[this.store.currentIssue]));
    let theIssue = this.store.rejections[this.store.currentIssue];
    //console.log(toJS(theIssue))
    //console.log(toJS(this.store.countryCodes));
    return (
      <div>
        <StyledHeader>
          <Typography variant='body1'>
            Issue {this.store.currentIssue + 1} of{' '}
            {this.store.rejections.length}
          </Typography>
        </StyledHeader>
        <IssueContainerDiv>
          <FormControl margin='dense' fullWidth variant='outlined'>
            <StyledInputLabel shrink id='issuetype-select-label'>
              Select Issue Type
            </StyledInputLabel>
            <Tooltip title='If we got it wrong, change the rejection type here'
                     enterDelay={toolTipDelay} >
              <Select
                labelId='issuetype-select-label'
                value={theIssue.basis}
                size='small'
                onChange = {e => {
                  console.log('Target', e.target);
                  theIssue.basis = e.target.value;
                }}
              >
                {Object.keys(this.store.issueTypes[this.store.matterType]).map((key, index) => {
                  return (
                    <MenuItem key={`issue_${index}`} value={key}>
                      {this.store.issueTypes[this.store.matterType][key]}
                    </MenuItem>
                  );
                })}
              </Select>
            </Tooltip>
          </FormControl>
        </IssueContainerDiv>

        <hr/>

        <TextField
          style={{width:"100%"}}
          label={theIssue.basis && issueDataFieldName[theIssue.basis]}
          value={theIssue.claims || ''}
          //defaultValue={theIssue.claims || ''}
          onChange={e=> {
            theIssue.claims = e.target.value;
          }}
          />

        {(['102', '103', 'ns_dp', 'pct.novelty', 'pct.inventive', 'refs.cited'].includes(theIssue.basis))
          && (
           <div>
             <Typography variant='body1'>References:</Typography>
             {theIssue.references.map((reference, index) => {
               return (
                 <div
                   style={{
                     paddingBottom: '5px',
                     marginBottom: '5px',
                     borderBottom: 'lightgray solid 0.5px'
                   }}
                   key={index}
                 >
                   <InnerRefContainerDiv>
                     <Tooltip title='Delete reference' enterDelay={toolTipDelay} placement='right'>
                       <IconButton
                         size='small' 
                         onClick={() => {
                           console.log('Deleting');
                           console.log(theIssue.references);
                           this.store.removeReference(index);
                         }}
                       >
                         <CancelOutlined />
                       </IconButton>
                     </Tooltip>
                     
                     <FormControl style={{marginRight:"5px", flexGrow:1}} margin='dense' variant='outlined'>
                       <StyledInputLabel shrink id='country-select-label'>
                         Country
                       </StyledInputLabel>
                       <Select
                         size='small'
                         labelId='country-select-label'
                         value={`${reference.country} ${reference.type}`}
                         onChange = {e => {
                           const [updatedCountry, updatedType] = e.target.value.split(' ');
                           this.store.updateReference(index, 'country', updatedCountry, false);
                           this.store.updateReference(index, 'type', updatedType, false);
                           //this.store.propagateRefInfo();
                         }}
                       >
                         {this.store.countryCodeOptions.map((cc, index) => {
                           return <MenuItem key={`cc_${index}`} value={cc}>{cc}</MenuItem>;
                         })}
                       </Select>
                     </FormControl>
                     
                     <Tooltip
                       title="Only numbers - no letters, commas, or slashes"
                       enterDelay={2000} >
                       <TextField
                         style={{flexGrow: 2}}
                         label='Reference Number'
                         value={reference.num}
                         onChange={e => {
                           const updatedNum = e.target.value;
                           this.store.updateReference(index, 'num', updatedNum);
                         }}
                       />
                     </Tooltip>
                   </InnerRefContainerDiv>
                   <InnerRefContainerDiv>
                     <span></span>
                     <TextField
                       label="Alias"
                       style={{width:"80%"}}
                       value={reference.alias}
                       onChange={e => {
                         const updatedAlias = e.target.value;
                         this.store.updateReference(index, 'alias', updatedAlias);
                       }}
                     />
                   </InnerRefContainerDiv>
                 </div>
               );
             })}
             <IssueContainerDiv>
               <Tooltip
                 title="Add another reference"
                 placement='right'
                 enterDelay={toolTipDelay} >
                 <IconButton
                   size='small'
                   onClick={() => {
                     this.store.addReference();
                   }}
                 >
                   <AddCircleOutline />
                 </IconButton>
               </Tooltip>
             </IssueContainerDiv>
           </div>
        )}

        <div style={{marginTop: 10}}>
          <Tooltip
          title="Delete this issue"
          enterDelay={toolTipDelay} >
            <Button
              color='secondary' variant='contained' disableElevation
              onClick={() =>
                this.store.removeIssue(this.store.currentIssue)
              }
            >
              Delete
            </Button>
          </Tooltip>
        </div>
      </div>
    );
  }

  render() {
    return <CardContainerDiv>{this.renderRejectionInfo()}</CardContainerDiv>;
  }
} 

export default CardContent;

